jQuery(document).ready(function ($) {
    // Show loading indicator on AJAX start
    $(document).ajaxStart(function () {
        $('#loading-indicator').show()
    })

    // Hide loading indicator on AJAX complete
    $(document).ajaxStop(function () {
        $('#loading-indicator').hide()
    })
})
